import React from 'react'

function proceeds() {
  return (
    <div>proceeds</div>
  )
}

export default proceeds